// extracted by mini-css-extract-plugin
export default {"pillsContainer":"PillsToolbar_pillsContainer__VmuHf","pill":"PillsToolbar_pill__MnEyf","pillBorder":"PillsToolbar_pillBorder__AX16v"};